module.exports = __webpack_public_path__ + "img/dongji_ps_01.9a92986d.jpg";